import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuestaoSelecaoVisualizacao = _resolveComponent("QuestaoSelecaoVisualizacao")!
  const _component_QuestaoSelecaoEdicao = _resolveComponent("QuestaoSelecaoEdicao")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.questao.getEmEdicao())
      ? (_openBlock(), _createBlock(_component_QuestaoSelecaoVisualizacao, {
          key: 0,
          questao: _ctx.questao,
          ehPrimeiro: _ctx.ehPrimeiro,
          ehUltimo: _ctx.ehUltimo,
          onEditar: _ctx.editar,
          onExcluir: _ctx.excluir,
          onDescer: _ctx.descer,
          onSubir: _ctx.subir,
          onSelecionar: _ctx.selecionar
        }, null, 8, ["questao", "ehPrimeiro", "ehUltimo", "onEditar", "onExcluir", "onDescer", "onSubir", "onSelecionar"]))
      : _createCommentVNode("", true),
    (_ctx.questao.getEmEdicao())
      ? (_openBlock(), _createBlock(_component_QuestaoSelecaoEdicao, {
          key: 1,
          questao: (_ctx.questao as QuestaoSelecaoEditavel)
        }, null, 8, ["questao"]))
      : _createCommentVNode("", true)
  ]))
}